<div class="card card-custom">
  <div class="card-header">
    <div class="card-title"></div>
    <div class="card-toolbar">
      <button type="button" (click)="onSave()" class="btn btn-icon btn-sm btn-success mr-2 p-1" style="width: 150px">
        Save
      </button>
      <button type="button" (click)="onClose()" class="btn btn-icon btn-sm btn-light-warning p-1">
        <i class="ki ki-close icon-nm"></i>
      </button>
    </div>
  </div>

  <div class="form">
    <div class="card-body">
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12 mb-4">
            <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.title">
              <input matInput formControlName="title" placeholder="Title" />
              <mat-hint [formFieldHintState]="form.controls.title">
                Title <span>required</span>
              </mat-hint>
              <mat-error>
                Title <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-12 mb-4">
            <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.option_name">
              <input matInput formControlName="option_name" placeholder="Option name" />
              <mat-hint [formFieldHintState]="form.controls.option_name">
                Option name <span>required</span>
              </mat-hint>
              <mat-error>
                Option name <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-12 mb-4">
            <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.option_description">
              <textarea matInput formControlName="option_description" placeholder="Description"></textarea>
              <mat-hint [formFieldHintState]="form.controls.option_description">
                Description <span>required</span>
              </mat-hint>
              <mat-error>
                Description <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>